import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { encode } from 'base-64';
import { Base64 } from 'js-base64';
import isValidJsonString from '../utils/is-valid-json-string';
import Guid from '../utils/guid';
import { CHANNEL_TYPES, API_RESPONSE_CODES, DEVICE_CODE, ALL_REPORT_PORTFOLIO, DATA_EXPORT_TYPE , PORTFOLIO_RELIDTYPE} from '../constants';

import moment from 'moment';
import getDateRangeInMoment from '../screens/data-exports/utils';

const DATA_EXPORTS_PATH = 'roster.data.dataExports';

export default () => muster()

.path('dataExports.user.selectedPortfolioId', variable(ALL_REPORT_PORTFOLIO))
.path('dataExports.user.selectedPortfolioData', variable())
.path('dataExports.user.portfoliosData', variable([]))
.path('dataExports.user.dataExportsPortfoliosData',variable([]))
.path('dataExports.user.setDataExportsPortfoliosData', {
  call: async ({ req }, { get, set, call }) => {
    const portfolioElements = [];

    const [userPFIds] = await getValues(
      get('app.user.portfoliosData')
    );
    userPFIds.map((portfolio) => {
      if (portfolio.isDownloadAvailable) {
        let existflag = false;
        portfolioElements.map((portfolioEle) => {
          if (
            portfolioEle.id === portfolio.id &&
            portfolioEle.relId === portfolio.relId
          ) {
            existflag = true;
          }
        });
        const key = portfolio.relId;
        if (!existflag) {
          if (key && key.substring(key.length - 4, key.length) !== 'CONS') {
            portfolioElements.push(portfolio);
          }
          else if (key === null) {
            portfolioElements.push(portfolio);
          }
        }
      }
      return portfolioElements;
    });

    const parsedPortfolioList = [];
    portfolioElements.map((portfolio) => {
      parsedPortfolioList.push(portfolio.title);
    });

    await set('dataExports.user.dataExportsPortfoliosData', portfolioElements);
    await set('dataExports.user.portfoliosData', parsedPortfolioList);
  }
    })


  .path('dataExports.initiateDataExtract', {
    call: async ({ req }, { get, set, call }) => {
      const [messages] = await getValues(get('i18n.messages'));

      const guidStr = Guid();

      const [result] = await
        getValues(
          get(`${DATA_EXPORTS_PATH}.initiateDataExtract["${guidStr}"]`)
        );

      isValidJsonString(result).then(async (data) => {
        if (data) {
          const returnCode = data.returnCode;
          await set('dataExports.initiateDataExtractResponse', data);
          if (returnCode === API_RESPONSE_CODES.SUCCESS) {
            await Promise.all([
              set('dataExports.initiateDataExtractResultValid', true),
              set('dataExports.loading', false)
            ]);
            return;
          }
          if (returnCode === API_RESPONSE_CODES.ERROR) {
            await Promise.all(
              [
              set('dataExports.blurModalError', true),
              set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
              set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
              set('dataExports.loading', false)
              ]);
            return;
          }
          // generic message
          await Promise.all(
            [set('dataExports.loading', false),
            set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
            set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
            set('dataExports.blurModalError', true),
            ]
          );
        }
      }).catch(async (error) => {
        await Promise.all(
          [
          set('dataExports.initiateDataExtractResponse', null),
          set('dataExports.loading', false),
          set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
          set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
          set('dataExports.blurModalError', true)]
        );
      });
    }
  }
  )

  .path('dataExports.getExtractVolume', {
    call: async ({ req }, { get, set, call }) => {
      const [messages] = await getValues(get('i18n.messages'));

      await set('dataExports.errorTitle', null);
      await set('dataExports.loading', true);

      const requestData  = req.args[0];
      /*  WMCE-6458 common selection widget */

    //   const [portfolioId] = await getValues(
    //     get('dataExports.user.selectedPortfolioId')
    //   );

    //     let pfIdArray = [];
    //   if (portfolioId.id === ALL_REPORT_PORTFOLIO.id) {
    //   const [portfolioIds] = await getValues(
    //     get('dataExports.user.portfoliosData')
    //   );
    //   if (!portfolioIds || portfolioIds.length === 0) {
    //     await call('dataExports.user.setDataExportsPortfoliosData');
    //     [pfIdArray] = await getValues(
    //       get('dataExports.user.portfoliosData')
    //     );
    //   }
    //   else {
    //     pfIdArray = portfolioIds;
    //   }
    // }
    // else {
    //   pfIdArray.push(portfolioId.title);
    // }
    let pfIdArray = [];
    const [portfolioId] = await getValues(
         get('app.user.selectedPortfolioData')
       );
    if(portfolioId.relIdType!=undefined && portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS){
 
       pfIdArray.push(portfolioId.relId);
    }
    else {
      pfIdArray.push(portfolioId.title);
    }

      const request = {
        reportname: req.args[0],
        fromDate: req.args[1],
        toDate: req.args[2],
        pfId: pfIdArray
      }

      const requestObj = Base64.encode(JSON.stringify(request));
      const guidStr = Guid();
      const inputParam = `${requestObj}`;


      const [result] = await
        getValues(
          get(`${DATA_EXPORTS_PATH}.getExtractVolume["${inputParam}"]["${guidStr}"]`)
      );

      isValidJsonString(result).then(async (data) => {
        if (data) {
          const returnCode = data.returnCode;

          await set('dataExports.getExtractVolumeResponse', data);

          if (returnCode === API_RESPONSE_CODES.SUCCESS) {
            if(data.isExportSizeLarge === DATA_EXPORT_TYPE.EXPORT_SIZE){

             await call('dataExports.custom.downloads.excelData', {
                reportname: req.args[0],
                fromDate: req.args[1],
                toDate: req.args[2],
                fileType: req.args[3]
              });
             return;
            }
            if(data.isExportSizeLarge === DATA_EXPORT_TYPE.EXPORT_SIZE_INVALID){
              await Promise.all(
                [
                  set('dataExports.errorTitle', ""),
                  set('dataExports.errorMessage', messages['app.dataExports.getExtractVolumeError']),
                  set('dataExports.loading', false),
                  set('dataExports.blurModalError', true)
                ]);
            }
          }

          if (returnCode === API_RESPONSE_CODES.ERROR) {
            await Promise.all(
          [
            set('dataExports.loading', false),
            set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
            set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
            set('dataExports.blurModalError', true)
              ]);
            return;
          }

          // generic message
          await Promise.all(
            [
              set('dataExports.loading', false),
              set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
              set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
              set('dataExports.blurModalError', true)
            ]
          );
        }
      }).catch(async (error) => {
        await Promise.all(
          [
            set('dataExports.loading', false),
            set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
            set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
            set('dataExports.blurModalError', true)
         ]
        );
      });
    }
  }
  )

  .path('dataExports.getDistinctDates', {
    call: async ({ req }, { get, set, call }) => {
      const [messages] = await getValues(get('i18n.messages'));
      // await set('dataExports.loading', true);

      const guidStr = Guid();
      let pfIdArray = [];

      const [portfolioId] = await getValues(
        get('app.user.selectedPortfolioData')
      );
   if(portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS){
     await call('portfolio.getSelectedIdData');
     [pfIdArray] = await getValues(
              get('user.selectedPortfolioIds')
            );
   }
   else {
     pfIdArray.push(portfolioId.title);
   }

    /*  WMCE-6458 common selection widget */

  //  const [portfolioId] = await getValues(
  //   get('dataExports.user.selectedPortfolioId')
  // );
    //     let pfIdArray = [];
    //   if (portfolioId.id === ALL_REPORT_PORTFOLIO.id) {
    //   const [portfolioIds] = await getValues(
    //     get('dataExports.user.portfoliosData')
    //   );
    //   if (!portfolioIds || portfolioIds.length === 0) {
    //     await call('dataExports.user.setDataExportsPortfoliosData');
    //     [pfIdArray] = await getValues(
    //       get('dataExports.user.portfoliosData')
    //     );
    //   }
    //   else {
    //     pfIdArray = portfolioIds;
    //   }
    // }
    //   else {
    //     pfIdArray.push(portfolioId.title);
    //   }
      const request = {
        reportname: req.args[0],
        pfId: pfIdArray
      }
      const requestObj = Base64.encode(JSON.stringify(request));
      const inputParam = `${requestObj}`;
      const [result] = await
        getValues(
          get(`${DATA_EXPORTS_PATH}.getDistinctDates["${inputParam}"]["${guidStr}"]`)
      );

      isValidJsonString(result).then(async (data) => {
        if (data) {
          const returnCode = data.returnCode;
          const [minDates] = await getValues(get('dataExports.initiateDataExtractResponse'));

          if (returnCode === API_RESPONSE_CODES.SUCCESS) {
            const momentDates = data.distinctDates.map(elem => moment((elem), "DD-MM-YYYY"));
            await Promise.all([
              set('dataExports.distinctDates', momentDates),
              set('dataExports.loading', false)
            ]);
            return;
          }

          if (returnCode === API_RESPONSE_CODES.ERROR_CODE) {

            const momentDates1 = getDateRangeInMoment(minDates, moment(), req.args[0]);
            await Promise.all([
              set('dataExports.distinctDates', momentDates1),
              set('dataExports.loading', false)
            ]);

            return;
          }

          const momentDates1 = getDateRangeInMoment(minDates, moment(), req.args[0]);
          await Promise.all(
            [
            set('dataExports.distinctDates', momentDates1),
            set('dataExports.loading', false),
            set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
            set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
            set('dataExports.blurModalError', true),
            ]
          );
        }
      }).catch(async (error) => {
        const momentDates1 = getDateRangeInMoment(minDates, moment(), req.args[0]);
        await Promise.all(
          [
          set('dataExports.distinctDates', momentDates1),
          set('dataExports.loading', false),
          set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
          set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
          set('dataExports.blurModalError', true)]
        );
      });
    }
  }
  )

  .path('dataExports.custom.downloads.excelData', {
    call: async ({ req, res }, { get, set, call }) => {
      const requestData  = req.args[0];
      let pfIdArray = [];

      const [messages] = await getValues(get('i18n.messages'));
     /*  WMCE-6458 common selection widget */

    //   const [portfolioId] = await getValues(
    //     get('dataExports.user.selectedPortfolioId')
    //   );

    //   if (portfolioId.id === ALL_REPORT_PORTFOLIO.id) {
    //   const [portfolioIds] = await getValues(
    //     get('dataExports.user.portfoliosData')
    //   );
    //   if (!portfolioIds || portfolioIds.length === 0) {
    //     await call('dataExports.user.setDataExportsPortfoliosData');
    //     [pfIdArray] = await getValues(
    //       get('dataExports.user.portfoliosData')
    //     );
    //   }
    //   else {
    //     pfIdArray = portfolioIds;
    //   }
    // }
    //   else {
    //     pfIdArray.push(portfolioId.title);
    //   }

    const [portfolioId] = await getValues(
      get('app.user.selectedPortfolioData')
    );
 if(portfolioId.relIdType !== PORTFOLIO_RELIDTYPE.PORTFOLIOS){
   pfIdArray.push(portfolioId.relId);
 
 }
 else {
   pfIdArray.push(portfolioId.title);}

      const pfIdParam = encode(pfIdArray.join('$'));
      const base64 = encode(JSON.stringify(requestData));
      const inputParam = `${pfIdParam}#@#${base64}`;
      const guidStr = Guid();
      const [oReturn] = await getValues(get(`roster.data.edelivery.positionDownloads.downloads["${inputParam}"]["${guidStr}"]`));
      isValidJsonString(oReturn).then(async(data) => {

        if(data && data.sections[0] && data.sections[0].headers && data.sections[0].headers.length > 0 && data.sections[0].results){
          await set('dataExports.custom.downloads.result', data);
          await set('dataExports.loading', false);
        }else{
          await Promise.all([
            set('dataExports.loading', false),
            set('dataExports.errorMessage', messages['app.dataExports.fetch.noData']),
            set('dataExports.blurModalError', true),
            set('dataExports.custom.downloads.result', null)
          ])
        }
      }).catch(async (error) => {
        await Promise.all(
          [
            set('dataExports.loading', false),
            set('dataExports.errorTitle', messages['app.dataExports.genericError.title']),
            set('dataExports.errorMessage', messages['app.dataExports.genericError.message']),
            set('dataExports.blurModalError', true),
            set('dataExports.custom.downloads.result', null)
          ]
        );
      });
    },
  })

  .path('dataExports.custom.downloads.result', variable())
  .path('dataExports.loading', variable(null))
  .path('dataExports.initiateDataExtractResponse', variable(null))
  .path('dataExports.initiateDataExtractResultValid', variable(false))
  .path('dataExports.getExtractVolumeResponse', variable(null))
  .path('dataExports.getExtractVolumeResultValid', variable(false))
  .path('dataExports.errorTitle', variable())
  .path('dataExports.errorMessage', variable(''))
  .path('dataExports.blurModalError', variable(false))
  .path('dataExports.initialDataExtractCall', variable(true))
  .path('dataExports.distinctDates', variable(null))
  .path('dataExports.portfoliosData', variable(null))
